import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
import { Plus } from '@element-plus/icons-vue';
import CommonInfoDialog from './CommonInfoDialog.vue';
import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';

import { ref, watch, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XTableSelect',
  props: {
    placeholder: {
      default: '请选择'
    },
    modelValue: {},
    labelkey: {},
    valuekey: {},
    tabelColunm: {},
    searchItems: {},
    url: {},
    loadUrl: {}
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const REQUEST = global.globalVal[GLOBAL_DATA.TABLE_REQUEST];
    const props = __props;
    const emits = __emit;
    const commonInfoDialog = ref();
    const selectRows = ref([]);
    const options = ref([]);
    watch(() => props.modelValue, () => {
      selectRows.value = props.modelValue || [];
      if (props.modelValue && props.modelValue.length > 0) {
        const loadIds = [];
        props.modelValue.forEach(item => {
          const i = options.value.find(i => i[props.valuekey] === item);
          if (!i) {
            loadIds.push(item);
          }
        });
        if (loadIds.length > 0) {
          loadIds.forEach(item => {
            REQUEST(props.loadUrl + '/' + item, null).then(res => {
              if (res.data) {
                options.value.push(res.data);
              }
            });
          });
        }
      }
    }, {
      immediate: true
    });
    const value = computed({
      get() {
        return props.modelValue || [];
      },
      set(newValue) {
        emits('update:modelValue', newValue);
      }
    });
    function select(rows) {
      options.value = [...rows];
      selectRows.value = rows.map(item => item[props.valuekey]);
      emits('update:modelValue', selectRows.value);
    }
    function selectCommon() {
      commonInfoDialog.value?.open();
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        placeholder: "Please input",
        class: "input-with-select"
      }, {
        prepend: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(value) ? value.value = $event : null),
          placeholder: _ctx.placeholder,
          style: {
            "width": "115px"
          },
          multiple: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item[props.labelkey],
              value: item[props.valuekey]
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "placeholder"])]),
        append: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: selectCommon,
          icon: _unref(Plus)
        }, null, 8, ["icon"])]),
        _: 1
      }), _createVNode(CommonInfoDialog, {
        ref_key: "commonInfoDialog",
        ref: commonInfoDialog,
        onSelect: select,
        tabelkey: props.valuekey,
        "default-select": _unref(selectRows),
        url: props.url,
        tabelColunm: props.tabelColunm,
        searchItems: props.searchItems
      }, null, 8, ["tabelkey", "default-select", "url", "tabelColunm", "searchItems"])]);
    };
  }
});